module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-2-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("‘K")]), _vm._v("ensington?’ Lucy repeated in surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That’s right.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The last Lucy had heard, Superintendent Magellan had been promoted to Chief Superintendent and was now working out of the posh shop, as she thought of it. It had been Magellan who’d kicked her out of the Met, and it was only thanks to her old boss that she hadn’t been fired, but ‘voluntarily transferred’ to Stockton. It had been a particularly traumatic and horrible time and Lucy had as much desire to see Magellan again as to swim in a vat of turds. In fact, she’d take the turd-swimming option any day. At least it would smell a lot sweeter.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Why me?’ Lucy asked her mother. ‘I haven’t seen Ricky for ages. And it’s not like he was my best friend or anything.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You were at school with him.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Well, yes. He was in my year and we shared classes, but I never really "), _c('i', [_vm._v("knew")]), _vm._v(" him.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Come on, Lucy. He wants you to–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I can’t see how I can help,’ Lucy overrode her. ‘It’s not my jurisdiction, remember?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But I told Jaya you’d go!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jaya had been her mother’s friend for as long as Lucy could remember. They’d become comrades at the school gates when they’d discovered they were both single mums. However, where Lucy’s dad had buggered off to Australia with a yoga teacher called Tina, Jaya’s husband had run off with another man. Even now, Lucy’s mother reckoned she’d got off lightly in comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Oh, Mum…’ Lucy rubbed her forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘She’s depending on you, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy wasn’t going to fold over any kind of emotional blackmail. She hadn’t seen Mac for three weeks, dammit. Why should she have her weekend hijacked?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m not with the Met any more, remember?’ Lucy firmed her resolve. ‘Tell her I’m sorry, but I can’t help.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Small silence.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re not saying that because of… well, our last conversation?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy blinked.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I know I was a bit harsh,’ her mother went on, ‘but I don’t think you should take it out on Jaya.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy sprang to her feet, suddenly furious. ‘How could you say such a thing?! I’d "), _c('i', [_vm._v("never")]), _vm._v(" do something so shitty! I’m saying I can’t help Ricky because I "), _c('i', [_vm._v("can’t")]), _vm._v(", not because you won’t tell me where my father is! What sort of person do you take me for?!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Okay, okay. Sorry.’ Her mother took a deep breath. ‘We’re just a bit upset over here, as you can imagine.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Right.’ Lucy fought to rein in her temper.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Would you like to speak to Jaya?’ her mother asked.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sorry, but no.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mac came in and topped up her wine. She gulped half a glass down in three swift swallows. He raised his eyebrows. Pushing her hair back, Lucy filled him in.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I can’t believe she thought I wouldn’t see Ricky because she wouldn’t tell me how to find Dad!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘She’s upset.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I know,’ Lucy sighed, feeling her tension ebb, the colours in her mind settling to muted tones. She returned to the sofa, curling her feet beneath her until Mac sank down next to her and brought them onto his lap. Lucy wriggled her toes. ‘I wish she’d tell me, though. I’m sure she knows where he is.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It was thanks to her kidnapper that Lucy wanted to track down her father. Facing her own mortality had made her reassess priorities in her life. Priorities like Mac, and her dad, whom she’d last seen when she was eight, waving him goodbye as his taxi left for Heathrow Airport. At the time, it had been pretty awful – she’d missed him dreadfully – but after a while she got used to him not being there and her mum had been amazing, bringing her up on her own.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She hadn’t wanted to find her father before, mainly because she felt she’d be betraying her mother by doing so, but when she’d looked death in the eye she’d pledged to track him down. Since then, her relationship with her mother had been shaky. Mum didn’t want her to be reunited with Dad, but Lucy wanted to see her father, full stop.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They were halfway through one of Lucy’s favourite movies, "), _c('i', [_vm._v("Memento")]), _vm._v(", when her phone rang again. A number she didn’t recognise. Knowing she could never resist answering the phone in case it might be an emergency, Mac paused the film.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Hello?’ Her voice was wary.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Lucy, it’s Jaya.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy squeezed her eyes shut, wishing she hadn’t answered. She really was her own worst enemy sometimes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Look, we really need your help, okay? Ricky and me. We’re at our wits’ end… He didn’t do it. I swear it. You know he wouldn’t hurt a fly…’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy had heard it all before in her job, but she didn’t interrupt. Just listened until eventually, Jaya said, ‘Please, Lucy. Will you see Ricky for me?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Jaya, I’m sorry.’ Lucy was firm. ‘I’m no longer with the Met, and–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What if I can tell you where your dad is?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("For a moment, Lucy thought she’d misheard. ‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘If you see Ricky, I’ll tell you how to find him.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy’s brain fired bolts of colour, electricity fizzing. She felt a sudden euphoria. Was this for real? Was Jaya telling the truth?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I promise,’ Jaya added.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That’s blackmail.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I guess you could call it that. Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Long silence.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy could feel Mac staring at her but her gaze was on the fireplace, the faux flames flickering.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How do you know where he is?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I just do, okay?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy had asked around locally the last time she’d been in Southwark, her childhood patch, but aside from the fact he’d gone to Australia, nobody knew anything more. At first, she’d thought it was because her father had vanished so completely he’d left no trace, but after a while she came to realise everyone’s silence was thanks to her mother threatening them with God alone knew what if they spilled any beans.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘He’s in Sydney, isn’t he?’ Lucy pressed.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Melbourne?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll tell you after you’ve seen my boy. But no, not Melbourne either.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy considered Jaya and her mother’s friendship. ‘What about Mum?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘She’ll kill me,’ Jaya said simply.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("But it’ll be worth it for Ricky")]), _vm._v(","), _c('i'), _vm._v("Lucy could hear her thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Okay.’ Lucy caved in. She would zip up to London tomorrow morning, see Ricky, hopefully dodge Super-shit Magellan and be back at Mac’s by teatime. And then she’d know where her dad was. And she’d see him. At last!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thanks, Lucy.’ Jaya exhaled. She sounded close to tears. ‘Thanks so much.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("When Lucy hung up, Mac gave a sigh. ‘So, we’re going to London tomorrow.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What do you mean, we?’ She looked at him, startled.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You don’t think I’m going to sit here twiddling my thumbs while you have all the excitement of visiting a murder suspect, do you?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You don’t have to come.’ She frowned. ‘I’ll be back in the afternoon.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He looked at her steadily. ‘Even so, I’d rather be with you than sitting at home, alone.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Awww.’ Lucy leaned over and gave him a kiss. ‘That’s really lovely.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll drive us up there.’ Mac stretched before reaching for the remote to switch the movie back on. ‘If we fancy it, we can always stay the night. Go to an exhibition or something.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucy felt her spirit brighten at the thought of making a weekend of it. What had felt like a chore now had the potential to turn into a mini-adventure. She fell asleep wrapped in Mac’s arms and for once, she didn’t awake in the middle of the night screaming for help. She slept dreamlessly. Quietly. And when morning came, fingers of sunlight slipped past the curtains, indicating it was past nine. Mac was still fast asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She was stifling a yawn, not wanting to wake him, when she heard her phone buzz. It was a text from Jaya.")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("Someone just tried to kill Ricky.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35288db0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-002.vue
// module id = 87
// module chunks = 0